import React, { useEffect, useState } from 'react'
import { CapacitorUpdater } from '@capgo/capacitor-updater'

import { Box, Typography } from '@mui/material'

export const AppInfo: React.FC = () => {
  const [currentVersion, setCurrentVersion] = useState<string>('-.-.-')
  const [nativeVersion, setNativeVersion] = useState<string>('-.-.-')

  useEffect(() => {
    const getCurrentVersion = async () => {
      const current = await CapacitorUpdater.current()
      if (!current.bundle.version) return
      setCurrentVersion(current.bundle.version)
    }

    const getNativeVersion = async () => {
      const bundle = await CapacitorUpdater.getBuiltinVersion()
      if (!bundle.version) return
      setNativeVersion(bundle.version)
    }

    getCurrentVersion()
    getNativeVersion()
  }, [])

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%">
      <Typography variant="body2" color="text.secondary">
        Informações sobre o <b>App MicroRED</b>:
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Versão OTA: {currentVersion}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Versão Nativa: {nativeVersion}
      </Typography>
    </Box>
  )
}
